<template>
  <div class="flex flex-col">
    <div class="grid-value items-start">
      <div class="flex flex-col">
        {{model.title}}
        <div class="text-sm text-gray-500">
          код: {{ model.code }} 
          <span class="italic">({{ model.type }}{{ model.required ? ', обязательный' : ''}})</span>
        </div>
      </div>
      <div class="flex flex-col">  
        <UInput v-if="model.value_type == USER_VALUE"
          v-model="model.value" :type="inputValueType(model)"/>
        <USelect v-else 
          v-model="model.value"
          value-attribute="code"
          option-attribute="code"
          :options="getSchema()"></USelect>  
        <span class="text-xs text-gray-500">{{ inputHint(model) }}</span>
      </div>
      <USelect
        v-if="valueCanSelected()"
        :options = "[
          {
            id: USER_VALUE,
            name: 'Значение'
          },
          {
            id: EVENT_VALUE,
            name: 'Из события'
          },
        ]"
        v-model="model.value_type"
        option-attribute="name"
        value-attribute="id"
      />
    </div>

    <TriggerMapping 
      v-if="model.items" 
      v-model="model.items"
      :level="level + 1"
      :parent="model"
      :event-schema="inflateSchema()"
    />
  </div>
</template>

<style scoped lang="scss">
.grid-value {
  @apply grid grid-cols-[260px,260px,140px] gap-3
}
</style>

<script lang="ts" setup>
import { EVENT_VALUE, USER_VALUE } from '~/types/marketing/marketing';
import { ARRAY_TYPE, OBJECT_TYPE, type IMarketingMaping } from '~/types/marketing/marketing-types';

const model = defineModel<IMarketingMaping>({required: true})

const props = defineProps<{
  eventSchema: []
  parent: any
  level: number
}>()  

const emit = defineEmits<{
  selectValue: [mm: IMarketingMaping]
  updateMapping: []
}>()

const inputHint = (mm: IMarketingMaping) => {
  return mm.value_type == USER_VALUE ? 
    'Введите значение' :
    'Выберите код события'
}

const inputValueType = (mm: IMarketingMaping) => {
  switch(mm.type) {
    case 'decimal': return 'number'
    default: return 'string'
  }
}

const inflateSchema = () => {
  if (
    (
      model.value.type === ARRAY_TYPE || 
      model.value.type === OBJECT_TYPE
    ) && model.value.value_type === EVENT_VALUE
  ) {
    const obj: any = props.eventSchema.find((i: any) => i.code === model.value.value)
    
    if (obj) return obj.items

    return []
  }

  return props.eventSchema
}

const valueCanSelected = () => {
  return !(
      model.value.type === ARRAY_TYPE || 
      model.value.type === OBJECT_TYPE
    ) && props.level === 0
}

const getSchema = () => {
  return props.eventSchema.filter(
    (s: any) => {
      return s.type === model.value.type
    }
  )
}
</script>